function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "8857239E-E4B9-44ED-AF6C-D8B085AA45D2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-851.000000, -91.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "PRIMERA"
}, React.createElement("g", {
  id: "icon-search",
  transform: "translate(848.000000, 88.000000)"
}, React.createElement("rect", {
  id: "bound",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), React.createElement("path", {
  d: "M20.725994,19.4402797 L16.6791556,15.3934426 C17.1709624,14.775172 17.5644015,14.0515245 17.8594834,13.2224811 C18.1545681,12.3934377 18.3021077,11.5292785 18.3021077,10.6299739 C18.3021077,9.57610702 18.0983629,8.58548414 17.6908652,7.65807828 C17.2974207,6.73067241 16.7529321,5.92271843 16.0573777,5.23418934 C15.3618233,4.54566295 14.5503567,3.99765898 13.6229508,3.59016393 C12.695545,3.19671681 11.7049221,3 10.6510552,3 C9.59718565,3 8.60656277,3.19671681 7.67915691,3.59016393 C6.75175104,3.99765898 5.9402844,4.54566295 5.24473054,5.23418934 C4.54917696,5.92271843 4.00468591,6.73067241 3.61124122,7.65807828 C3.20374504,8.58548414 3,9.57610702 3,10.6299739 C3,11.6978968 3.20374504,12.695545 3.61124122,13.6229508 C4.00468591,14.550354 4.54917696,15.358308 5.24473054,16.0468371 C5.9402844,16.7353661 6.75175104,17.2833701 7.67915691,17.6908652 C8.60656277,18.0843096 9.59718565,18.2810291 10.6510552,18.2810291 C11.5503544,18.2810291 12.4004657,18.1334895 13.2014052,17.8384075 C14.0023446,17.5433228 14.7400428,17.1498838 15.4145186,16.6580796 L19.461357,20.7049167 C19.5597194,20.8032778 19.6686171,20.8735347 19.7880555,20.9156895 C19.9074939,20.9578443 20.0093663,20.9789214 20.0936782,20.9789214 C20.1779873,20.9789214 20.2798597,20.9578443 20.3992981,20.9156895 C20.5187365,20.8735347 20.6276342,20.8032778 20.725994,20.7049167 C20.9086656,20.5222459 21,20.3114752 21,20.0725982 C21,19.8337211 20.9086656,19.6229505 20.725994,19.4402797 Z M4.81264637,10.6299739 C4.81264637,9.82903442 4.960186,9.07026031 5.25526932,8.35362728 C5.56440434,7.65105027 5.98243357,7.03278778 6.50936701,6.49882634 C7.03630314,5.9648676 7.65807558,5.55035264 8.37470861,5.25526797 C9.07728562,4.94613268 9.83606243,4.79156774 10.6510552,4.79156774 C11.4660453,4.79156774 12.2248221,4.94613268 12.9274018,5.25526797 C13.6440321,5.55035264 14.2658046,5.9648676 14.7927407,6.49882634 C15.3196742,7.03278778 15.7377045,7.65105027 16.0468398,8.35362728 C16.3419217,9.07026031 16.4894614,9.82903442 16.4894614,10.6299739 C16.4894614,11.4449667 16.3419217,12.2037435 16.0468398,12.9063205 C15.7517551,13.6089002 15.3302148,14.234188 14.7822028,14.7822001 C14.7822028,14.7822001 14.7822028,14.7822001 14.7822028,14.7822001 C14.7822028,14.7822001 14.7822028,14.7822001 14.7822028,14.7822001 C14.2482413,15.3161615 13.6299788,15.7341891 12.9274018,16.0362991 C12.2248221,16.3384064 11.4660453,16.4894614 10.6510552,16.4894614 C9.83606243,16.4894614 9.07728562,16.3348937 8.37470861,16.0257584 C7.65807558,15.7166258 7.03630314,15.2985955 6.50936701,14.7716621 C5.98243357,14.244726 5.56440434,13.6229535 5.25526932,12.9063205 C4.960186,12.2037435 4.81264637,11.4449667 4.81264637,10.6299739 Z",
  id: "search",
  fill: "#FFFFFF"
})))));

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.0c02bf20.svg";
export { ForwardRef as ReactComponent };